theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      if (!offcanvasOpen || !offcanvasClose || !offcanvasHeader) return;

      /* Add a Button For SubMenu Toggle */
      offcanvasMenu.forEach((item) => {
        item
        .querySelectorAll(".offcanvas__sub_menu")
        .forEach(function (ul) {
          const subMenuToggle = document.createElement("button");
          subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
          subMenuToggle.setAttribute("aria-label", "Submenu openen of sluiten");
          ul.parentNode.appendChild(subMenuToggle);
        });


      });
      
      const openMenu = function () {
        offcanvasHeader.classList.add("open");
        offcanvasHeader.setAttribute("aria-hidden", "false");
        offcanvasOpen.setAttribute("aria-expanded", "true");
        body.style.overflowY = "hidden";
        if (typeof trapFocus === "function") {
          trapFocus(offcanvasHeader, offcanvasClose);
        } else {
          offcanvasClose.focus();
        }
      };

      const closeMenu = function (returnFocus) {
        if (!offcanvasHeader.classList.contains("open")) return;
        offcanvasHeader.classList.remove("open");
        offcanvasHeader.setAttribute("aria-hidden", "true");
        offcanvasOpen.setAttribute("aria-expanded", "false");
        body.style.overflowY = "";
        if (typeof removeTrapFocus === "function") {
          removeTrapFocus(returnFocus ? offcanvasOpen : null);
        } else if (returnFocus) {
          offcanvasOpen.focus();
        }
      };

      /* Open/Close Menu On Click Toggle Button */
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        openMenu();
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        closeMenu(true);
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && offcanvasHeader.classList.contains("open")) {
          closeMenu(true);
        }
      });
      
      
      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
        .querySelectorAll(".offcanvas__sub_menu_toggle")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.parentElement;
            if (parent.classList.contains("active")) {
              this.classList.remove("active");
              parent.classList.remove("active");
              parent
              .querySelectorAll(".offcanvas__sub_menu")
              .forEach(function (subMenu) {
                subMenu.parentElement.classList.remove("active");
                subMenu.nextElementSibling.classList.remove("active");
                slideUp(subMenu);
              });
            } else {
              this.classList.add("active");
              parent.classList.add("active");
              slideDown(this.previousElementSibling);
              getSiblings(parent).forEach(function (item) {
                item.classList.remove("active");
                item
                .querySelectorAll(".offcanvas__sub_menu")
                .forEach(function (subMenu) {
                  subMenu.parentElement.classList.remove("active");
                  subMenu.nextElementSibling.classList.remove("active");
                  slideUp(subMenu);
                });
              });
            }
          });
        });                   
      })
      

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            const focusIsInsideMenu = offcanvasHeader.contains(document.activeElement);
            closeMenu(focusIsInsideMenu);
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          closeMenu(false);
        }
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();
